<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      finish-button-text="Modifier"
      back-button-text="Précédant"
      next-button-text="suivant"
      class="wizard-vertical mb-3"
      @on-complete="updateClient"
    >
      <!-- account datails tab -->
      <tab-content title="Client">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Client</h5>
            <small class="text-muted">
              Information général sur le client.
            </small>
          </b-col>
          <b-col md="6">
            <b-form-group label="Nom" label-for="v-nom">
              <b-form-input
                id="v-nom"
                placeholder="Nom"
                v-model="client.firstName"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Prénom" label-for="v-prenom">
              <b-form-input
                id="v-prenom"
                placeholder="Prénom"
                v-model="client.lastName"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Email" label-for="v-email">
              <b-form-input
                id="v-email"
                placeholder="Email"
                v-model="client.email"
              />
            </b-form-group>
          </b-col>
          <!-- <b-col md="12">
            <b-form-group label="Numéro de téléphone" label-for="v-numero">
              <b-form-input
                id="v-numero"
                placeholder="numero"
                v-model="client.telNumbers"
              />
            </b-form-group>
          </b-col> -->

          <b-col md="12">
            <b-form
              ref="form"
              :style="{ height: trHeight + 150 }"
              class="repeater-form"
              @submit.prevent="repeateAgain"
            >
              <!-- Row Loop -->
              <b-row
                v-for="(item, index) in items"
                :id="item.id"
                :key="item.id"
                ref="row"
              >
                <!-- Item Name -->
                <b-col lg="9" md="9">
                  <b-form-group
                    label="Numéro de téléphone"
                    label-for="v-numero"
                  >
                    <b-form-input
                      id="v-numero"
                      placeholder="numero"
                      v-model="item.value"
                    />
                  </b-form-group>
                </b-col>
                <!-- Remove Button -->
                <b-col lg="1" md="1" class="mb-50">
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2"
                    @click="removeItem(index)"
                  >
                    <feather-icon icon="XIcon" class="mr-25" />
                  </b-button>
                </b-col>
                <b-col lg="1" md="1" class="mb-50">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-0 mt-md-2"
                    @click="repeateAgain"
                  >
                    <feather-icon icon="PlusIcon" class="mr-25" />
                  </b-button>
                </b-col>
              </b-row>
              <!-- <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="repeateAgain"
              >
                <feather-icon icon="PlusIcon" class="mr-25" />
                <span>Ajouter un nouveau numéro</span>
              </b-button> -->
              <b-col cols="12">
                <hr />
              </b-col>
            </b-form>
          </b-col>
        </b-row>
      </tab-content>

      <!-- personal info tab -->
      <tab-content title="Adresse client">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Adresse client</h5>
            <small class="text-muted">Adresse du client en détail</small>
          </b-col>
          <b-col md="8">
            <b-form-group label="Ville" label-for="v-ville">
              <b-form-input
                id="v-ville"
                placeholder="ville"
                v-model="client.city"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Code postal" label-for="v-cp">
              <b-form-input
                id="v-cp"
                placeholder="Code Postal"
                v-model="client.postalCode"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Adresse" label-for="v-adresse">
              <b-form-input
                id="v-adresse"
                placeholder="adresse"
                v-model="client.address"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="client.position">
            <b-form-group label="Longitude" label-for="v-Longitude">
              <b-form-input
                id="v-Longitude"
                placeholder="00.0000"
                v-model="client.position.lng"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="client.position">
            <b-form-group label="Latitude" label-for="v-Latitude">
              <b-form-input
                id="v-Latitude"
                placeholder="00.0000"
                v-model="client.position.lat"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>
      <tab-content title="Autre informations">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Autre informations</h5>
            <small class="text-muted">Autre informations</small>
          </b-col>
          <b-col md="4">
            <b-form-group label="Raison sociale" label-for="v-Raison">
              <b-form-input
                id="v-Raison"
                placeholder="Raison sociale"
                v-model="client.socialReason"
              />
            </b-form-group>
          </b-col>
          <!-- <b-col md="4">
            <b-form-group label="Code postal" label-for="v-cp">
              <b-form-input
                id="v-cp"
                placeholder="ville"
                v-model="client.postalCode"
              />
            </b-form-group>
          </b-col> -->
          <b-col md="4">
            <b-form-group label="Secteur d'activité" label-for="v-activite">
              <b-form-input
                id="v-activite"
                placeholder="Secteur d'activité"
                v-model="client.activityArea"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Nom du responsable, Poste"
              label-for="v-responsable"
            >
              <b-form-input
                id="v-responsable"
                placeholder="Nom du responsable, Poste"
                v-model="client.responsible"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Type du client" label-for="v-Type">
              <b-form-input
                id="v-Type"
                placeholder="Type du client"
                v-model="client.type"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Type de vente" label-for="v-vente">
              <b-form-input
                id="v-vente"
                placeholder="Type de vente"
                v-model="client.saleType"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Remise" label-for="v-Discount">
              <b-form-input
                id="v-Discount"
                placeholder="Remise"
                v-model="client.discount"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Matricule Fiscale" label-for="v-Matricule">
              <b-form-input
                id="v-Matricule"
                placeholder="Matricule Fiscale"
                v-model="client.registrationNumber"
              />
            </b-form-group>
          </b-col>
          <b-col md="8">
            <b-form-group label="Jours de visite" label-for="v-Days">
              <v-select
                id="v-Days"
                v-model="client.visitingDays"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                multiple
                label="title"
                :options="optionDays"
                placeholder="Jours de visite"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { heightTransition } from "@core/mixins/ui/transition";
import VueBarcode from "vue-barcode";
import axios from "axios";
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BImg,
  BRow,
  BCol,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormGroup,
  BFormFile,
  BFormInput,
  BFormTextarea,
  BForm,
  BButton,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BButton,
    BForm,
    VueBarcode,
    BImg,
    BFormFile,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      items: [],
      nextTodoId: 2,
      optionCategorie: [],
      optionSubCategorie: [],
      optionDays: [
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
        "Dimanche",
      ],
      client: {
        createdBy: JSON.parse(localStorage.getItem("userData"))._id,
        firstName: "",
        lastName: "",
        email: "",
        telNumbers: [],
        city: "",
        address: "",
        postalCode: "",
        position: {
          lat: "",
          lng: "",
        },
        socialReason: "",
        activityArea: "",
        responsible: "",
        type: "",
        saleType: "",
        discount: "",
        registrationNumber: "",
        visitingDays: [],
      },
    };
  },
  mounted() {
    axios
      .get(
        "https://management-projects.herokuapp.com/api/customers/" +
          this.$router.history.current.query.id
      )
      .then((response) => {
        this.client = response.data;
        response.data.telNumbers.forEach((element, index) => {
          this.items.push({ id: index + 1, value: element });
        });
        this.nextTodoId = response.data.telNumbers.length + 1;
        console.log("test", this.items, this.nextTodoId);
      })
      .catch((error) => {
        this.errorMessage = error.message;
      });

    setTimeout(this.initTrHeight(), 500);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  created() {
    window.addEventListener("load", this.initTrHeight);
  },
  methods: {
    // itemsss() {
    //   console.log("tetete");
    //   this.items = [];
    //   this.client.telNumbers.forEach((element, index) => {
    //     this.items.push({ id: index + 1, value: element });
    //   });
    //   this.initTrHeight();
    // },
    repeateAgain() {
      this.items.push({
        id: (this.nextTodoId += this.nextTodoId),
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },

    updateClient() {
      console.log(this.client, this.items);
      this.client.telNumbers = [];
      this.items.forEach((element) => {
        this.client.telNumbers.push(element.value);
      });
      console.log(this.client, this.items);
      this.client.createdBy = this.client.createdBy._id;
      this.client.updatedBy = this.client.updatedBy._id;
      axios
        .put(
          "https://management-projects.herokuapp.com/api/customers/" +
            this.$router.history.current.query.id,
          this.client
        )
        .then((response) => {
          console.log(response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Client bien ajouté",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$router.replace("/Client");
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
